import SiutEditor from './siut-editor'

export default SiutEditor;
